import { useMutation } from "@tanstack/react-query";
import { DELETE_USER } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseData, EntityWithPagination } from "api/types";
import { IReturnType } from "hooks/types";
import { SnackbarSeverity } from "hooks/useSnackbar";
import IUser from "models/Employee";

type Props = {
  callback?: () => void;
  id: string;
  showSnackbar?: (message: string, severity: SnackbarSeverity) => void;
};

export const useDeleteUserMutation = ({ callback, showSnackbar }: Props) => {
  const {
    mutate,
    isLoading,
    isError,
    isSuccess,
    refetch,
  }: IReturnType<ApiResponseData<EntityWithPagination<IUser>>> = useMutation(
    [DELETE_USER],
    (id: string) => fetchApi(`users`).delete(`/${id}`),
    {
      onSuccess: () => {
        showSnackbar && showSnackbar("Employee Deleted Successfully", "success");
        callback && callback();
      },
      onError: (error) => {
        showSnackbar("Failed to Delete Employee", "error");
      },
    }
  );
  return { isLoading, isError, isSuccess, mutate, refetch };
};
